module.exports = __webpack_public_path__ + "static/img/14.3a455ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/14.png
// module id = o80N
// module chunks = 0